(() => {
  if (window.brCartRecommendationsInitialized) return;
  window.brCartRecommendationsInitialized = true;

  const refreshRecommendations = async () => {
    const elements = document.querySelectorAll('[data-br-cart-recommendations]');
    if (!elements.length) return;

    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const productId = cart.items?.[0]?.product_id;

      elements.forEach((element) => {
        if (!productId) {
          element.remove();
          return;
        }
        if (element.dataset.productId === String(productId) && element.innerHTML.trim()) return;
        element.dataset.productId = productId;
        element.innerHTML = '';
        element.initializeRecommendations?.(productId);
      });
    } catch (error) {
      // Keep the last valid recommendations when a cart refresh fails.
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshRecommendations);
    }
  });
})();
